module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921132649_T.4c318471.jpg";